/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatsMitmItem
 */
export interface StatsMitmItem {
    /**
     * 
     * @type {string}
     * @memberof StatsMitmItem
     */
    mitm_domain?: string;
    /**
     * 
     * @type {number}
     * @memberof StatsMitmItem
     */
    view_count?: number;
    /**
     * 
     * @type {number}
     * @memberof StatsMitmItem
     */
    unique_ip_count?: number;
    /**
     * 
     * @type {string}
     * @memberof StatsMitmItem
     */
    token_tag?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StatsMitmItem
     */
    allowed_domains?: Array<string>;
}

/**
 * Check if a given object implements the StatsMitmItem interface.
 */
export function instanceOfStatsMitmItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatsMitmItemFromJSON(json: any): StatsMitmItem {
    return StatsMitmItemFromJSONTyped(json, false);
}

export function StatsMitmItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsMitmItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mitm_domain': !exists(json, 'mitm_domain') ? undefined : json['mitm_domain'],
        'view_count': !exists(json, 'view_count') ? undefined : json['view_count'],
        'unique_ip_count': !exists(json, 'unique_ip_count') ? undefined : json['unique_ip_count'],
        'token_tag': !exists(json, 'token_tag') ? undefined : json['token_tag'],
        'allowed_domains': !exists(json, 'allowed_domains') ? undefined : json['allowed_domains'],
    };
}

export function StatsMitmItemToJSON(value?: StatsMitmItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mitm_domain': value.mitm_domain,
        'view_count': value.view_count,
        'unique_ip_count': value.unique_ip_count,
        'token_tag': value.token_tag,
        'allowed_domains': value.allowed_domains,
    };
}

